/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import classnames from 'classnames';
import './pagination.scss';

export default class Pagination extends React.Component {
  input = React.createRef();

  prev = () => {
    if (this.props.page > 1) {
      this.props.setPage(this.props.page - 1);
    }
  };

  next = () => {
    if (this.props.page < this.props.lastPage) {
      this.props.setPage(this.props.page + 1);
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const page = Number(this.input.current.value);

    if (!Number.isNaN(page) && page > 0 && page <= this.props.lastPage) {
      this.props.setPage(page);
    }
  };


  render() {

    const className = classnames(this.props.className, 'pagination__container');

    return (
      <form onSubmit={this.handleSubmit} className={className}>
        <a className="pagination__previous" onClick={this.prev}>&lt;</a>
        <input
          className="pagination__page-input"
          data-qa-ref="pagination-page-input"
          key={this.props.page}
          defaultValue={this.props.page}
          maxLength={String(this.props.lastPage).length}
          ref={this.input} />
        /
        <span className="pagination__last-page">{this.props.lastPage}</span>
        <a className="pagination__next" onClick={this.next}>&gt;</a>
      </form>
    );
  }
}
